export interface IUseBotaoLimparSelecaoProps {
    hasSelectedRows?: boolean;
    selectedRowKeys?: any[] | null;
}

export function checkHasSelectedRows(selectedRowKeys?: any[] | null): boolean {
    return !!selectedRowKeys && selectedRowKeys.length > 0;
}

export const useBotaoLimparSelecao = ({
    hasSelectedRows,
    selectedRowKeys,
}: IUseBotaoLimparSelecaoProps) => {
    const isSelected = hasSelectedRows !== undefined
        ? hasSelectedRows
        : checkHasSelectedRows(selectedRowKeys);

    return {
        isSelected,
    };
};

export default useBotaoLimparSelecao;
